import * as actionTypes from './actionTypes';

export function hideModal() {
  return function(dispatch) {
    dispatch({type: actionTypes.HIDE_MODAL});
  }
};
